export const events = {
  web: {
    web_getStarted: "web_getStarted",
    web_getAppLink: "web_getAppLink",
    web_home_downloadSixer: "web:home_downloadSixer",
    web_home_aboutReferrals: "web:home_aboutReferrals",
    web_home_inviteFriends: "web:home_inviteFriends",
    web_home_CTA_legality: "web:home_CTA_legality",
    web_home_CTA_contact: "web:home_CTA_contact",
    web_home_CTA_ambassadorProgram: "web:home_CTA_ambassadorProgram",
    web_home_CTA_dailyInsights: "web:home_CTA_dailyInsights",
    web_home_startTrading: "web:home_startTrading",
    web_home_CTA_tickerBar: "web:home_CTA_tickerBar",
    web_ambassador_inviteFriends: "web:ambassador_inviteFriends",
    web_ambassador_getStarted: "web:ambassador_getStarted",
    web_contact_submitForm: "web:contact_submitForm",
    web_contact_downloadSixer: "web:contact_downloadSixer",
    web_about_startTrading: "web:about_startTrading",
    web_careers_join: "web:careers_join",
    web_home_CTA_India1st: "web:home_CTA_India1st",
  },
  android: {
    Android_download: "Android_download",
  },
  ios: {
    iOS_download: "iOS_download",
  },
}
